import React, {useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import ExamesListar from '../section-pages/exames-listar';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiExames from '../services/exameService';

export default function Exames() {
  const [exames, setExames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchExames = async () => {
     try {
       const response = await ApiExames.listar();
       setExames(response.data.exames);
     } catch (error) {
       console.error('Erro ao buscar eventos:', error);
     } finally {
       setIsLoading(false);
     }
   };
 
   useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }
    fetchExames();
   }, []);

  return (
    <>
    {/* HEAD */}
    <Helmet>
      <link rel="icon" href="./img/icon.png" />
      <title>Fetron - Federação de Taekwondô de Rondônia</title>
    </Helmet>

    {/* LOADER */}
    <div id='mainpreloader'>
      <Preloader/>
    </div>

    {/* MENU */}
    <div className="home dark-scheme">
      <header id="header-wrap">
         <Navbar />
      </header>

      <section className="no-bg">
          <div>
            <img src="../../img/background/bg-header.png" width="100%"/>
          </div>
          <div className="container z-9">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <center>
                  <h3 className="titulo">Exames</h3>
                </center>
              </div>        
            </div>
          </div>
        </section>

      {/* section */}
      <section className="no-top">
        <ExamesListar exames={exames}/>
      </section>

      {/* footer */}
      <Footer/>


    </div>
    <ScrollToTopBtn />
    </>
  )
}
